export const COMPARISON_LIMIT = 6;

export const getComparisonProductId = (value) => {
  if (value == null) return "";
  if (typeof value === "string" || typeof value === "number") return String(value);
  return String(value._id || value.id || "");
};

const asList = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }
  const normalized = String(value || "").trim();
  return normalized ? [normalized] : [];
};

const yesNoUnknown = (value) => {
  if (value === true) return "Так";
  if (value === false) return "Ні";
  return null;
};

export const COMPARISON_CHARACTERISTICS = [
  { key: "manufacturer", label: "Виробник", read: (product) => product.manufacturer },
  { key: "countryOfOrigin", label: "Країна-виробник товару", read: (product) => product.countryOfOrigin },
  { key: "category", label: "Категорія / тварина", read: (product) => asList(product.category) },
  { key: "kind", label: "Вид товару", read: (product) => product.kind },
  { key: "type", label: "Тип товару", read: (product) => product.type },
  { key: "purpose", label: "Призначення", read: (product) => asList(product.purpose) },
  { key: "weight", label: "Вага / розмір упаковки", read: (product) => product.weight },
  { key: "feedClass", label: "Клас корму", read: (product) => product.feedClass },
  { key: "animalAge", label: "Вік тварини", read: (product) => asList(product.animalAge) },
  { key: "breed", label: "Порода", read: (product) => asList(product.breed) },
  { key: "forSterilized", label: "Для стерилізованих тварин", read: (product) => yesNoUnknown(product.forSterilized) },
  { key: "hypoallergenic", label: "Гіпоалергенність", read: (product) => yesNoUnknown(product.hypoallergenic) },
  { key: "mainIngredients", label: "Основні інгредієнти", read: (product) => asList(product.mainIngredients), long: true },
];

export const hasKnownComparisonValue = (value) =>
  Array.isArray(value)
    ? value.length > 0
    : value !== null && value !== undefined && String(value).trim() !== "";

export const formatComparisonValue = (value) => {
  if (!hasKnownComparisonValue(value)) return "Не вказано";
  return Array.isArray(value) ? value.join(", ") : String(value);
};

export const normalizeComparisonValue = (value) => {
  if (!hasKnownComparisonValue(value)) return "__unknown__";
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim().toLocaleLowerCase("uk-UA")).sort().join("|");
  }
  return String(value).trim().toLocaleLowerCase("uk-UA");
};

export const buildComparisonRows = (products, differencesOnly = false) =>
  COMPARISON_CHARACTERISTICS.filter((row) =>
    products.some((product) => hasKnownComparisonValue(row.read(product))),
  ).filter((row) => {
    if (!differencesOnly) return true;
    return new Set(products.map((product) => normalizeComparisonValue(row.read(product)))).size > 1;
  });
